module.exports = __webpack_public_path__ + "img/kayak001.31bd694f.jpg";